var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ins',{staticClass:"adsbygoogle",style:(_vm.adStyle),attrs:{"data-ad-client":_vm.adClient,"data-ad-slot":_vm.adSlot,"data-ad-format":_vm.adFormat}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76f4b10a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-adsense/VueAdsense.vue
// module id = 1202
// module chunks = 0